export const GET_SUBJECT = 'GET_SUBJECT';
export const UPDATE_MARKER = 'UPDATE_MARKER';